/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconClose from '@telus-uds/palette-koodo/build/rn/icons/Close'
import PaletteIconCheckCircleFilled from '@telus-uds/palette-koodo/build/rn/icons/CheckCircleFilled'
import PaletteIconExclamationTriangle from '@telus-uds/palette-koodo/build/rn/icons/ExclamationTriangle'
import PaletteIconExclamationOctagon from '@telus-uds/palette-koodo/build/rn/icons/ExclamationOctagon'
import PaletteIconTagFilled from '@telus-uds/palette-koodo/build/rn/icons/TagFilled'
const theme = {
  appearances: {
    style: {
      type: 'variant',
      values: [ 'system', 'success', 'warning', 'error', 'subtle' ]
    },
    system: { type: 'state', values: [ true ] },
    validation: {
      description: 'Validation states for form inputs',
      type: 'state',
      values: [ 'error', 'success', 'warning', 'feature' ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { system: true },
      tokens: {
        borderLeftWidth: 0,
        borderRadius: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        iconGap: 8
      }
    },
    {
      if: { style: 'system' },
      tokens: {
        borderLeftWidth: 0,
        borderRadius: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        iconGap: 8
      }
    },
    {
      if: { style: 'subtle' },
      tokens: {
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderRadius: 6,
        borderRightWidth: 0,
        borderTopWidth: 0,
        iconGap: 8
      }
    },
    {
      if: { style: 'success' },
      tokens: {
        backgroundColor: '#c5f2cc',
        borderColor: '#1c7b2b',
        color: '#000000',
        icon: PaletteIconCheckCircleFilled,
        iconColor: '#1c7b2b'
      }
    },
    {
      if: { validation: 'success' },
      tokens: {
        backgroundColor: '#c5f2cc',
        borderColor: '#1c7b2b',
        color: '#000000',
        icon: PaletteIconCheckCircleFilled,
        iconColor: '#1c7b2b'
      }
    },
    {
      if: { style: 'warning' },
      tokens: {
        backgroundColor: '#fff5d2',
        borderColor: '#f8c100',
        color: '#000000',
        dismissIcon: null,
        icon: PaletteIconExclamationTriangle,
        iconColor: '#c9370b'
      }
    },
    {
      if: { validation: 'warning' },
      tokens: {
        backgroundColor: '#fff5d2',
        borderColor: '#f8c100',
        color: '#000000',
        dismissIcon: null,
        icon: PaletteIconExclamationTriangle,
        iconColor: '#c9370b'
      }
    },
    {
      if: { style: 'error' },
      tokens: {
        backgroundColor: '#fcd3c6',
        borderColor: '#c9370b',
        color: '#000000',
        dismissIcon: null,
        icon: PaletteIconExclamationOctagon,
        iconColor: '#c9370b'
      }
    },
    {
      if: { validation: 'error' },
      tokens: {
        backgroundColor: '#fcd3c6',
        borderColor: '#c9370b',
        color: '#000000',
        dismissIcon: null,
        icon: PaletteIconExclamationOctagon,
        iconColor: '#c9370b'
      }
    },
    {
      if: { validation: 'feature' },
      tokens: {
        backgroundColor: '#e0d8fc',
        borderColor: '#7a3dfc',
        color: '#000000',
        dismissIcon: null,
        icon: PaletteIconTagFilled,
        iconColor: '#7a3dfc'
      }
    }
  ],
  tokens: {
    backgroundColor: '#efefef',
    borderBottomWidth: 1,
    borderColor: '#000000',
    borderLeftWidth: 1,
    borderRadius: 6,
    borderRightWidth: 1,
    borderTopWidth: 1,
    color: '#000000',
    containerPaddingLeft: 0,
    containerPaddingRight: 0,
    dismissButtonGap: 24,
    dismissIcon: PaletteIconClose,
    dismissIconColor: '#000000',
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '400',
    icon: null,
    iconColor: null,
    iconGap: 8,
    iconSize: 24,
    justifyContent: 'flex-start',
    lineHeight: 1.5,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12
  }
}
export default theme
